export default __webpack_public_path__ + "static/code-en-poche_picto-8161cd83dbc200552f527d82cf6831d5.png";